module.exports = __webpack_public_path__ + "img/runtu.0e101924.png";